import { render, staticRenderFns } from "./TextsForm.vue?vue&type=template&id=73ed4447&scoped=true&lang=pug&"
import script from "./TextsForm.vue?vue&type=script&lang=js&"
export * from "./TextsForm.vue?vue&type=script&lang=js&"
import style0 from "./TextsForm.vue?vue&type=style&index=0&id=73ed4447&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ed4447",
  null
  
)

export default component.exports